/**
 * 加载图片资源
 * @param {*} url 路径
 * @returns Promise<img>
 */
export function loadImg(url) {
  const img = new Image();

  img.src = url;
  img.crossOrigin = 'anonymous';

  return new Promise((resolve, reject) => {
    img.addEventListener('load', () => {
      resolve(img);
    });

    img.addEventListener('error', (err) => {
      console.log('img 加载失败', err);
      
      reject(err);
    })
  })
}

/**
* 加载js资源
* @param {*} url 路径
* @returns Promise<img>
*/
export function loadJs(url) {
  const script = document.createElement('script');

  script.src = url;

  document.head.appendChild(script);

  return new Promise((resolve, reject) => {
    script.addEventListener('load', () => {
      resolve();
    });

    script.addEventListener('error', (err) => {
      console.log('js 加载失败', err);

      reject();
    })
  })
}

/**
 * 数字保留小位
 * @param {*} number 
 * @param {*} count 
 * @returns 
 */
export function fixedNumber(number, count = 2) {
  return Number(Number(number).toFixed(count));
}

export function getImageSizeByContainer(
  width,
  height,
  containerWidth,
  containerHeight,
  isTianMu
) {
  const widthProps = width / containerWidth;
  const heightProps = height / containerHeight;

    // 天幕直接平铺
    if (isTianMu) {
      return {
          width: containerWidth,
          height: containerHeight
        }
    }

  // 横向压缩
  if (widthProps > heightProps) {
    return {
      width: containerWidth,
      height: height / widthProps
    }
  }

  return {
    width: width / heightProps,
    height: containerHeight
  }
};

/**
 * 获取链表最后一个node
 * @param {*} node 
 */
export function getLastNodeFromQueue(node) {
  let lastNode = null;
  let curNode = node;

  while (curNode) {
    if (curNode.next) {
      curNode = curNode.next;
    } else {
      lastNode = curNode;
      break;
    }
  }

  return lastNode;
}

/**
 * 根据rowListInfo对图层进行纵向还是横向均分
 * @param {*} rowListInfo 
 */
export function calDivideEquallyByRowListInfo(rowListInfo, canvasWidth, canvasHeight) {
  let rowCount = 0;
  let colCount = 0;
  let gapWidth = canvasWidth;
  let gapHeight = canvasHeight;
console.log('divideRowListInfo 99999', 9999);

  rowListInfo.forEach(({row, col, maxTop, maxBottom, maxLeft, maxRight }) => {
    if (row > col) {
      rowCount++
    } else {
      colCount++
    }
    gapHeight = gapHeight - (maxBottom - maxTop)
    gapWidth = gapWidth - (maxRight - maxLeft)
  })

  if (rowCount > colCount) {
    // y轴为主
    const singleGrap = gapHeight / (rowListInfo.length + 1);
    const returnData = rowListInfo.sort((a, b) => a.maxBottom - b.maxBottom);
    let lastBottom = 0;

    returnData.forEach((item, index) => {
      const y = lastBottom + singleGrap;
  
      item.moveY = Number(Number(y - item.maxTop).toFixed(1));
      lastBottom = y + (item.maxBottom - item.maxTop);
    })

    return {
      type: 'col',
      data: returnData
    }

  } else {
    // x轴为主
    const singleGrap = canvasWidth / (rowListInfo.length + 1);
    const returnData = rowListInfo.sort((a, b) => a.maxRight - b.maxRight);

    let lastRight = 0;

    returnData.forEach((item, index) => {
      const x = lastRight + singleGrap;

      item.moveX = Number(Number(x - item.maxLeft).toFixed(1));
      lastRight = x + (item.maxRight - item.maxLeft);
    })

    return {
      type: 'row',
      data: returnData
    }
  }

  // return rowCount > colCount ? 'row' : 
}